export { DescriptiveGeneratorComponent } from './descriptive-generator.component';
export { generateData } from './distributions.util';
export type { DataGeneratorConfig, DistributionShape } from './descriptive-generator.model';
export { SAMPLE_SIZE_PRESETS, DECIMAL_PLACES_OPTIONS } from './descriptive-generator.model';
export type { LibraryDataset } from './library-datasets.model';
export { LIBRARY_DATASETS } from './library-datasets.model';
